module.exports = __webpack_public_path__ + "img/20181215.2e3e1517.png";